module.exports = __webpack_public_path__ + "static/media/MEGAM.fb5d3f82.svg";